const startOfWeek: Record<string, number> = {
  // fri:-3, sat:-2, sun:-1
  MV: -3,
  AE: -2,
  AF: -2,
  BH: -2,
  DJ: -2,
  DZ: -2,
  EG: -2,
  IQ: -2,
  IR: -2,
  JO: -2,
  KW: -2,
  LY: -2,
  OM: -2,
  QA: -2,
  SD: -2,
  SY: -2,
  AG: -1,
  AS: -1,
  AU: -1,
  BD: -1,
  BR: -1,
  BS: -1,
  BT: -1,
  BW: -1,
  BZ: -1,
  CA: -1,
  CN: -1,
  CO: -1,
  DM: -1,
  DO: -1,
  ET: -1,
  GT: -1,
  GU: -1,
  HK: -1,
  HN: -1,
  ID: -1,
  IL: -1,
  IN: -1,
  JM: -1,
  JP: -1,
  KE: -1,
  KH: -1,
  KR: -1,
  LA: -1,
  MH: -1,
  MM: -1,
  MO: -1,
  MT: -1,
  MX: -1,
  MZ: -1,
  NI: -1,
  NP: -1,
  PA: -1,
  PE: -1,
  PH: -1,
  PK: -1,
  PR: -1,
  PT: -1,
  PY: -1,
  SA: -1,
  SG: -1,
  SV: -1,
  TH: -1,
  TT: -1,
  TW: -1,
  UM: -1,
  US: -1,
  VE: -1,
  VI: -1,
  WS: -1,
  YE: -1,
  ZA: -1,
  ZW: -1,
};

const WEEK = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export default function weekLocaleHelper() {
  const locale = navigator.language ?? "en-US";
  const country = locale.split("-")[1];
  const index = startOfWeek[country] ? startOfWeek[country] : 0;

  const weekDaysToReorder = index < 0 ? WEEK.slice(index) : [];

  const firstDayOfWeekIndex = index < 0 ? 7 + index : index;
  const firstDayOfWeek = WEEK[firstDayOfWeekIndex];

  const getOrderedWeek = () => {
    if (index === 0) {
      return WEEK;
    }
    return WEEK.slice(index).concat(WEEK.slice(0, index));
  };

  return { weekDaysToReorder, getOrderedWeek, firstDayOfWeek, firstDayOfWeekIndex };
}
